// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PpZy","selected":"styles_selected__2PSA0"};